var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchangeOneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.3333,
    cy: 30,
    r: 30,
    fill: "#E3E9EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 40.1667C21.9077 40.1667 21.6205 40.0507 21.3885 39.8187C21.1565 39.5867 21.0409 39.2999 21.0417 38.9584C21.0417 38.616 21.1577 38.3288 21.3897 38.0968C21.6217 37.8648 21.9085 37.7492 22.25 37.75H36.75C37.0924 37.75 37.3796 37.866 37.6116 38.098C37.8436 38.33 37.9592 38.6168 37.9584 38.9584C37.9584 39.3007 37.8424 39.5879 37.6104 39.8199C37.3784 40.0519 37.0916 40.1675 36.75 40.1667H22.25ZM26.5396 34.8198C26.3785 34.8198 26.2275 34.7945 26.0865 34.7437C25.9455 34.693 25.8146 34.6076 25.6938 34.4875L20.5584 29.3521C20.3368 29.1306 20.2261 28.8386 20.2261 28.4761C20.2261 28.1136 20.3368 27.8216 20.5584 27.6C20.7799 27.3785 21.0618 27.2678 21.4042 27.2678C21.7466 27.2678 22.0285 27.3785 22.25 27.6L26.5396 31.8896L36.75 21.6792C36.9716 21.4577 37.2587 21.3469 37.6116 21.3469C37.9644 21.3469 38.2512 21.4577 38.4719 21.6792C38.6934 21.9007 38.8042 22.1879 38.8042 22.5408C38.8042 22.8936 38.6934 23.1804 38.4719 23.4011L27.3854 34.4875C27.2646 34.6084 27.1337 34.6942 26.9927 34.7449C26.8518 34.7957 26.7007 34.8206 26.5396 34.8198Z",
    fill: "#00525D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeOneIcon);
export default __webpack_public_path__ + "static/media/exchange-one-icon.1b8c5926a0c1039da45c078017505a1f.svg";
export { ForwardRef as ReactComponent };